import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { googleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sid = match[1];
    googleSession(sid)
      .then(() => {
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google");
        navigate("/", { replace: true });
      })
      .catch((e) => {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      });
  }, [googleSession, navigate]);

  return (
    <div className="app-shell flex items-center justify-center min-h-screen" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-block w-10 h-10 rounded-full bg-[#234B38]/10 animate-soft-pulse" />
        <p className="text-sm text-[#5C7568] mt-4">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
